import { useState } from "react";
import { useUpdateInspection } from "../hooks/useInbound";
import { Button } from "@tonic/shared/components/ui";
import { Input } from "@tonic/shared/components/ui";
import { Label } from "@tonic/shared/components/ui";
import { Textarea } from "@tonic/shared/components/ui";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@tonic/shared/components/ui";
import { Card, CardContent } from "@tonic/shared/components/ui";
import { Badge } from "@tonic/shared/components/ui";

export function InspectionForm({ item }) {
  const updateInspection = useUpdateInspection(item.id);
  const [inspectionData, setInspectionData] = useState(
    item.items.map((i) => ({
      id: i.id,
      condition: i.condition || "",
      notes: i.notes || "",
      images: i.images || [],
    }))
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await updateInspection.mutateAsync({ items: inspectionData });
    } catch (error) {
      console.error("Failed to update inspection:", error);
    }
  };

  const handleItemUpdate = (index, field, value) => {
    setInspectionData((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [field]: value };
      return updated;
    });
  };

  const conditions = [
    { value: "like_new", label: "Like New" },
    { value: "excellent", label: "Excellent" },
    { value: "good", label: "Good" },
    { value: "fair", label: "Fair" },
    { value: "poor", label: "Poor" },
  ];

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      {item.items.map((itemData, index) => (
        <Card key={itemData.id}>
          <CardContent className="p-6">
            <div className="space-y-4">
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="font-medium">{itemData.name}</h3>
                  <p className="text-sm text-muted-foreground">{itemData.sku}</p>
                </div>
                <Badge variant="outline">Item {index + 1}</Badge>
              </div>

              <div className="grid gap-4 md:grid-cols-2">
                <div className="space-y-2">
                  <Label>Condition</Label>
                  <Select
                    value={inspectionData[index].condition}
                    onValueChange={(value) =>
                      handleItemUpdate(index, "condition", value)
                    }
                  >
                    <SelectTrigger>
                      <SelectValue placeholder="Select condition" />
                    </SelectTrigger>
                    <SelectContent>
                      {conditions.map((condition) => (
                        <SelectItem key={condition.value} value={condition.value}>
                          {condition.label}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>

                <div className="space-y-2">
                  <Label>Images</Label>
                  <Input
                    type="file"
                    multiple
                    accept="image/*"
                    onChange={(e) =>
                      handleItemUpdate(index, "images", Array.from(e.target.files))
                    }
                  />
                </div>
              </div>

              <div className="space-y-2">
                <Label>Inspection Notes</Label>
                <Textarea
                  value={inspectionData[index].notes}
                  onChange={(e) =>
                    handleItemUpdate(index, "notes", e.target.value)
                  }
                  placeholder="Enter any damage, wear, or other observations..."
                  rows={3}
                />
              </div>
            </div>
          </CardContent>
        </Card>
      ))}

      <div className="flex justify-end space-x-2">
        <Button
          type="submit"
          disabled={updateInspection.isLoading}
        >
          {updateInspection.isLoading ? "Saving..." : "Save Inspection"}
        </Button>
      </div>
    </form>
  );
} 